import React from "react";
import "./Gift_Card.css";
import { useNavigate } from "react-router-dom";

const Gift_Card = ({ imgSrc, productName, path}) => { 

  const navigate = useNavigate()

  return (
    <div className="Gift_Card" onClick={() => {navigate(path)}}>
      <div className="bg_color_div">
        <div className="img_holder">
          <img src={imgSrc} className="gift_img" />
        </div>
      </div>
      <p className="product_name">{productName}</p>
    </div>
  );
};

export default Gift_Card;
